import { WysiwygAction } from '../../adapter/wysiwyg-adapter.types';
import { Placeholder } from '../placeholder';

export type WysiwygPlaceholderChangeAction = WysiwygAction<
  ActionType.PlaceholderChange,
  Placeholder
>;

export type WysiwygPlaceholderDeleteAction = WysiwygAction<
  ActionType.PlaceholderDelete,
  Placeholder
>;

export enum ActionType {
  PlaceholderChange = 'PlaceholderChange',
  PlaceholderDelete = 'PlaceholderDelete',
}

export type WysiwygPlaceholderAction =
  | WysiwygPlaceholderChangeAction
  | WysiwygPlaceholderDeleteAction;
